import * as ng from 'angular';
import * as _ from 'underscore';

import {EditorPageModel, EditorController} from './';

export class EditorPageController implements ng.IController {
   page:EditorPageModel;
   editorCtrl:EditorController;

   // To avoid code copying, in some editors, we reuse the same
   // html for the main site as we do for an editor. This boolean
   // allows us to check whether that html is in an editor or not.
   readonly isEditor:boolean = true;

   private observer:MutationObserver;

   static $inject = ['$element', '$sce', '$timeout'];

   constructor(
      private $element:ng.IAugmentedJQuery,
      private $sce:ng.ISCEService,
      private $timeout:ng.ITimeoutService
   ) { }

   $postLink() {
      // mutation callbacks are very frequent and are not exclusive to content
      // updates (e.g. when switching active page)
      // debounce helps with performance
      this.observer = new MutationObserver(_.debounce((mutations) => {
         this.onPageUpdate();
      }, 500));
      this.observer.observe(this.$element[0], {
         childList: true,
         attributes: true,
         subtree: true
      });
   }

   $onDestroy() {
      if (this.observer) {
         this.observer.disconnect();
      }
   }

   private onPageUpdate() {
      let page = this.$element.children().first();
      let layers = page.children('.page-layer');

      let thumbs = _.map(layers.get(), e => {
         let height = e.clientHeight < 500 ? 500 : e.clientHeight;
         let scale = 115 / height;

         // Strip out id's from tinymce textboxes to prevent
         // them from collapsing.
         let regex = /id="ui-tinymce-(\d)+"/g;
         let replace = e.outerHTML.replace(regex,"");

         let regex2 = /ng-hide/g;
         replace = replace.replace(regex2, "");

         let regex3 = /display: none;/g;
         replace = replace.replace(regex3, "");

         this.editorCtrl.hideSpinner();

         return {
            html: this.$sce.trustAsHtml(replace),
            scale: `scale(${scale})`,
            width: e.clientWidth * scale,
            height: height * scale,
            contentWidth: e.clientWidth,
            contentHeight: height,
            page: this.page
         };
      });

      // set page thumbnails in angular digest cycle so other directives see changes
      if (thumbs && thumbs.length > 0) {
         this.$timeout(() => this.page.thumbs = thumbs, 0);
      }
   }

   get isActivePage() {
      return this.editorCtrl.active == this.page;
   }

   isActiveLayer(index:number) {
      return this.isActivePage && this.editorCtrl.active.layerIndex === index;
   }

   // These convenience properties are here to provide short hand versions
   // for common property paths in the editor views (e.g. $ctrl.settings
   // instead of $ctrl.page.editorCtrl.model.experience.settings) but also
   // serve as a common/sane property path for use in the QR site and Media
   // site controllers that share their template view with the editor.

   /**
    * Convenience property. Get current language from editor model.
    */
   get language() {
      return this.editorCtrl.model.language;
   }

   /**
    * Convenience property. Get campaign languages from editor model.
    */
   get languages() {
      return this.editorCtrl.model.languages;
   }

   /**
    * Convenience property. Get experience settings from model.
    */
   get settings() {
      return this.editorCtrl.model.settings;
   }

   /**
    * Convenience property. Get campaign model.
    */
   get campaign() {
      return this.editorCtrl.model.campaign;
   }
}

ng.module('e360').component('editorPage', {
   templateUrl: require('./editor-page.html'),
   require: {
      editorCtrl: '^editor'
   },
   controller: EditorPageController,
   bindings: {
      page: '<'
   }
});
